import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-upload-center',
  templateUrl: './document-upload-center.component.html',
  styleUrls: ['./document-upload-center.component.scss']
})
export class DocumentUploadCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
